<script>
import { mapGetters } from 'vuex'
import cartHelper from '@/components/app/cart/helper'
export default {
  name: 'cart-info',
  mixins: [cartHelper],
  methods: {
    navigateToCart () {
      this.$router.push(this.cartRoute)
    }
  },
  computed: {
    ...mapGetters('cart', ['cartCount']),
    cartRoute () {
      return { name: 'cart.list' }
    },
    title () {
      return `${this.$tc('item', this.cartCount)} ${this.$t('in your cart')}`
    }
  }
}
</script>
<template>
  <b-card
    no-body
    v-bind="$attrs"
    v-on="$listeners"
    bg-variant=""
    class="mini-stats-wid icon-grow pointer"
    v-if="cartCount > 0"
    v-on:click="navigateToCart"
  >
    <b-card-body>
      <div class="d-flex align-items-center">
        <div class="flex-grow-1">
          <h4 class="mb-2">{{ cartCount }}</h4>
          <p class="text-muted mb-0 fw-medium text-uppercase">{{ title }}</p>
          <b-btn
            class="alert-link m-0 p-0 mt-1"
            variant="link"
            :to="cartRoute"
            >{{ $t('view cart') }}</b-btn
          >
        </div>
        <b-avatar
          variant="secondary"
          class="mini-stat-icon font-size-20 mx-4"
          size="lg"
        >
          <div :class="['bx bx-cart', 'grow']"></div>
        </b-avatar>
      </div>
    </b-card-body>
  </b-card>
</template>
